import styled, { css } from 'styled-components'

const iconSize = '18px'

const Span = styled.span`
  display: block;
  width: ${props => (props.icon !== 'left' && props.icon !== 'right' ? '100%' : `calc(100% - ${iconSize})`)};
  height: 100%;
  line-height: 20px;
  text-align: center;
`

const Button = styled.button`
  width: 120px;
  height: 24px;
  font-size: 14px;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  svg {
    width: ${iconSize};
    height: ${iconSize};
  }

  ${props =>
    props.theme === 'primary' &&
    css`
      background: var(--orange);
      border: 1px solid var(--orange);
      color: #fff;
      svg {
        fill: #fff;
      }
      span {
        text-indent: ${props => (props.icon !== 'left' && props.icon !== 'right' ? 0 : iconSize)};
      }

      &:hover {
        background: #fff;
        color: var(--orange);
        text-align: center;
        svg {
          fill: var(--orange);
        }
      }

      &:active {
        background: rgba(242, 102, 46, 0.2);
        color: var(--orange);
        text-align: center;
        svg {
          fill: var(--orange);
        }
      }
    `}

  ${props =>
    props.theme === 'secundary' &&
    css`
      background: #fff;
      border: 1px solid #00ceff;
      color: #24143e;
      text-align: center;
      svg {
        fill: #24143e;
      }
      span {
        text-indent: -${iconSize};
      }

      &:hover {
        background: #00ceff;
        color: #fff;
        svg {
          fill: #fff;
        }
      }

      &:active {
        background: #00ceff;
        color: #24143e;
        svg {
          fill: #24143e;
        }
      }
    `}

    ${props =>
    props.isLoading &&
    css`
      background: #fff;
      border: 1px solid #9c9c9c;
      text-align: center;
      svg {
        width: 40px;
        height: 20px;
        position: absolute;
        left: 0;
        right: 0;
      }
    `}

    ${props =>
    props.disabled &&
    css`
      background: #9c9c9c;
      border: 1px solid #9c9c9c;
      color: #fff;
      text-align: center;
      cursor: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAvlJREFUOBGVlF9I01EUx8+9m9tDLc2oh5RCaRQWIUT00B966g/IfJARBIkpKBGkg8Jmf3Yrcsz+uOwlLU0s6GEIYYX5JkQ9CIEEhhjtQa0ggqbrZW77nb53c2u/MUZe+N17zz3nfO65957fEVSgHVXKWr0cryeDXYJoLwt2CnQwDaObJinGogtzL0OhUDLfHfbm1uTxHpYsBoUgZ0rDNA3W0urcJoTYj7mViWcNotbhXv+7XIIJ2NLhvUhCBIh4CZH0WwQ9fXzfP5fr0NrZWZpcEWeIpA/r5cTcORj0383YZIHNHV0+RKWYadlKtGsg2P0jY1Ro1OBEzPICPicRgG+w139T26WAZ9u9dVKKVzhGVJBwADoRLrPVTSqVKATLWRMtHV2ToBwhprrBYPcb6Xa7LYD16cgShrGHmcew6/HqSGxUP06Oc6Epx4U4DdgfBNOnlJLSUelsgGWVEHxn5EFgPlxmb0hDhet/oCO9t78Bdg2PVT2/FK+XgGkgWaT9kR71MdcKNcg+rH3xQCcksmufToGBe+pXahHdWqHDQRUB4zMJPoSU4y3E4msGlhnXCsXrzoNTqY+sW2ZMS6v9PyhN4I6K3imzSAIqNWgBoW43kXIEDY2W2Vw6lYpB8ahbwfmOOxQfkHs1LR5VnsMxTUNKrRSDNp73bsKGtfg+SkE8rr2ZY40mSp5QDFpio3OIXuDAo0IntqNixxyyfbNMJGuePOxZzGOZRLdSNkdkJZX8qXy1yAtsGDM45c/lxS9OmSpBTB79yxlWy3N4Z/9vE2lVyI+Uk/wJvuvg1q5ZWWcUB4WgfbiHcbIlTg319EQLATNrjZ4rFSXMs9h+PXyuDwW7b2ldFqiFZk/XJVymH9fxm8i4YbHxs4FAIF0LtQFac/vVnSSTTXBsA2gDxssFy1fanAg18SC26cdeu7GWQF2cwpPFtR4ZUQpdbdqWZ1AU2gB7n5bTvSnCjEKhaixEYi7Ix5jEAeRY1aouDMgUInu7baP9NexQtM3tL4+OdUV00mdpAAAAAElFTkSuQmCC),
        default !important;
      svg {
        fill: #fff;
      }

      &:hover {
        background: #9c9c9c;
        border: 1px solid #9c9c9c;
        color: #fff;
        svg {
          fill: #fff;
        }
      }
    `}
`

export { Button, Span }
